import { PROXIED_ENVS } from "PFCore/utilities/routes";

export type SupplyUtilizationData = {
  utilisation_graph: {
    billable_utilisation: number;
    total_utilisation: number;
    date: string;
  }[];
};

export type SupplyTotalStats = {
  availability: number;
  billable_utilisation: number;
  capacity: number;
  categories: Record<string, number>;
  total_utilisation: number;
};

export type SupplyStatsData = {
  total_stats: SupplyTotalStats;
};

export const fetchSupplyUtilization = (
  accessToken: string,
  fullDomain: string,
  params: Record<string, string>
): Promise<SupplyUtilizationData> =>
  /* @ts-ignore */
  $.ajax({
    url: `${PF.config.insights_api_endpoint}/booking_module_supply_utilisation`,
    method: "get",
    headers: {
      profindaapitoken: accessToken,
      account: fullDomain,
      ...(PROXIED_ENVS.includes(PF.config.environment ?? "") ? null : { sessionHost: PF.config.api_endpoint })
    },
    data: params
  });

export const fetchSupplyStats = (
  accessToken: string,
  fullDomain: string,
  params: Record<string, string>
): Promise<SupplyStatsData> =>
  /* @ts-ignore */
  $.ajax({
    url: `${PF.config.insights_api_endpoint}/booking_module_supply_stats`,
    method: "get",
    headers: {
      profindaapitoken: accessToken,
      account: fullDomain,
      ...(PROXIED_ENVS.includes(PF.config.environment ?? "") ? null : { sessionHost: PF.config.api_endpoint })
    },
    data: params
  });
